import { render, staticRenderFns } from "./KnowledgeProcessDetails.vue?vue&type=template&id=75cd64cc&"
import script from "./KnowledgeProcessDetails.vue?vue&type=script&lang=js&"
export * from "./KnowledgeProcessDetails.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeProcessDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KnowledgeProcessDetails.vue"
export default component.exports